import React from 'react';
import moment from 'moment';
import { observer } from 'mobx-react';
import { GlobalToken } from 'antd';

import { LegendLabelContainer } from './LegendLabel.styles';

interface LegendLabelProps {
  name: string;
  deviceName?: string;
  startDate?: string | number | Date;
  endDate?: string | number | Date;
  token: GlobalToken;
}

const LegendLabel = observer(({ name, deviceName, startDate, endDate, token }: LegendLabelProps) => {
  const dateFormat = 'ddd, D MMM YYYY';
  const startDateFormatted = startDate ? moment(startDate).format(dateFormat) : null;
  const endDateFormatted = endDate ? moment(endDate).format(dateFormat) : null;

  return (
    <LegendLabelContainer theme={{ token }}>
      <div className={'name'}>
        {name}
        {deviceName ? <> - {deviceName}</> : null}
      </div>
      {startDateFormatted && endDateFormatted && (
        <div className={'dates'}>
          {startDateFormatted} - {endDateFormatted}
        </div>
      )}
    </LegendLabelContainer>
  );
});

export default LegendLabel;
